import md5 from 'js-md5'
import { visitorAuthLogin, rsaEncrypt, logout } from '@/api/login'
import { clearLoginSession } from '@/utils/auth'
import Cookies from 'js-cookie'
import { setLocalItem } from '@/utils/token'
import { generateRSAKeyPair, rsaDecrypt } from '@/utils/jsencrypt'
import { encryptWithAES } from '@/utils/secret'

const user = {
  state: {
    // token: getToken("token"),
    // refreshToken: getRefreshToken(),
    name: '',
    avatar: '',
    roles: [],
    rsaPublicKey: '',
    rsaPrivateKey: '',
  },

  mutations: {
    RESET_AUTH_STATE: (state) => {
      state.token = ''
      state.refreshToken = ''
      state.name = ''
      state.avatar = ''
      state.roles = []
      state.permissions = []
      state.userId = null
      state.rsaPublicKey = ''
      state.rsaPrivateKey = ''
    },
    SET_TOKEN: (state, token) => {
      Cookies.set('token', token)
    },
    SET_REFRESHTOKEN: (state, refreshToken) => {
      state.refreshToken = refreshToken
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_RSA_PUBLICKEY: (state, publicKey) => {
      state.rsaPublicKey = publicKey
    },
    SET_RSA_PRIVATEKEY: (state, privateKey) => {
      state.rsaPrivateKey = privateKey
    },
  },

  actions: {
    // 企业个性化配置
    // ConfInfo({ commit }, confInfo) {
    //   return new Promise((resolve) => {
    //     commit("SET_CONF_INFO", confInfo);
    //     localStorage.setItem("confInfo", JSON.stringify(confInfo));
    //     resolve();
    //   });
    // },

    // 刷新token
    // RefreshToken({ commit }, refreshToken) {
    // return new Promise((resolve, reject) => {
    //   const params = {
    //     refreshToken
    //   }
    //   tokenRefresh(params)
    //     .then((res) => {
    //       setToken(res.data.accessToken)
    //       commit('SET_TOKEN', res.data.accessToken)
    //       setRefreshToken(res.data.refreshToken)
    //       commit('SET_REFRESHTOKEN', res.data.refreshToken)
    //       resolve(res)
    //     })
    //     .catch((error) => {
    //       reject(error)
    //     })
    // })
    // },

    // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     authLogin()
    //       .then((res) => {
    //         if (res && res.token) {
    //           let { username, token, id } = res;
    //           let avatar = require("@/assets/images/profile.jpg");
    //           commit("SET_NAME", username);
    //           commit("SET_AVATAR", avatar);
    //           commit("SET_TOKEN", token);
    //           commit("SET_USERID", id);
    //           setLocalItem(
    //             "useInfo",
    //             JSON.stringify({
    //               ...res,
    //               avatar,
    //             })
    //           );
    //           resolve(res);
    //           return res;
    //         }
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },

    // 获取 rsa 密钥
    async GetRsaKey({ commit }) {
      const ras = await generateRSAKeyPair()
      const { publicKey, privateKey } = ras
      commit('SET_RSA_PUBLICKEY', publicKey)
      commit('SET_RSA_PRIVATEKEY', privateKey)
    },

    // 生成签名，要求按属性名排序拼接
    GenerateSignatureWithMD5({ commit, state }, params = {}) {
      const filterKey = state.rsaPublicKey.replace(/[\n\r]/g, '')

      const signatureStr = Object.keys(params)
        .sort()
        .reduce((acc, cur) => {
          if (cur == 'key') {
            return acc + cur + filterKey
          }
          return acc + cur + params[cur]
        }, '')
      const signature = md5(signatureStr)
      return signature
    },

    Encryption({ commit, state, dispatch }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          await dispatch('GetRsaKey')

          const timestamp = new Date().getTime()
          params.timestamp = timestamp
          params.key = state.rsaPublicKey.replace(/\r/g, '')

          const { password, force, ...rest } = params
          const signature = await dispatch('GenerateSignatureWithMD5', rest)
          rest.signature = signature
          const res = await rsaEncrypt(rest)

          // 使用rsa私钥解密
          const decryptedText = rsaDecrypt(state.rsaPrivateKey, res.data)
          // 返回的 json 是单引号，无法直接 parse，需要替换成双引号
          const parseData = JSON.parse(decryptedText.replace(/'/g, '"'))

          resolve(parseData)
        } catch (error) {
          reject(error)
        }
      })
    },

    // 游客登录
    GetStaffInfo({ commit, state, dispatch }, params) {
      return new Promise(async (resolve, reject) => {
        const parseData = await dispatch('Encryption', params)

        const { key: pkKey, ...rest } = params
        const { key, iv } = parseData
        const timestamp = new Date().getTime()

        const signature = await dispatch('GenerateSignatureWithMD5', {
          ...rest,
          timestamp,
        })
        const encryptParams = {
          ...rest,
          timestamp,
          signature,
        }

        const encrypted = encryptWithAES(key, JSON.stringify(encryptParams), iv)

        const loginParams = {
          data: encrypted,
          username: params.username,
        }
        visitorAuthLogin(loginParams)
          .then((res) => {
            if (res && res.token) {
              let { username, token, id } = res
              let avatar = ''
              commit('SET_NAME', username)
              commit('SET_AVATAR', avatar)
              commit('SET_TOKEN', token)
              commit('SET_USERID', id)
              setLocalItem(
                'useInfo',
                JSON.stringify({
                  ...res,
                  avatar,
                })
              )
              resolve(res)
              return res
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 用户协议是否已读
    // IsReadClause({ commit }, isReadClause) {
    //   return new Promise((resolve) => {
    //     commit("SET_ISREADCLAUSE", isReadClause);
    //     resolve();
    //   });
    // },

    // 退出系统
    async LogOut({ commit }) {
      try {
        await logout()
      } catch (error) {
        // 已撤销或缺少凭证等同于已退出，不再触发登录。
        if (error.response?.status !== 401) throw error
      } finally {
        clearLoginSession()
        commit('RESET_AUTH_STATE')
      }
    },

    // 当前路由
    // ActiveRouter({ commit }, activeRouter) {
    //   return new Promise((resolve) => {
    //     commit("SET_ACTIVEROUTER", activeRouter.list);
    //     commit("SET_ACTIVETITLE", activeRouter.title);
    //     commit("SET_ACTIVEBASEPATH", activeRouter.basePath);
    //     localStorage.setItem("activeRouter", JSON.stringify(activeRouter.list));
    //     localStorage.setItem("activeTitle", activeRouter.title);
    //     localStorage.setItem("activeBasePath", activeRouter.basePath);
    //     resolve();
    //   });
    // },

    // 清除当前路由
    // ClearActiveRouter({ commit }) {
    //   return new Promise((resolve) => {
    //     commit("SET_ACTIVEROUTER", []);
    //     commit("SET_ACTIVETITLE", "");
    //     commit("SET_ACTIVEBASEPATH", "");
    //     localStorage.removeItem("activeRouter");
    //     localStorage.removeItem("activeTitle");
    //     localStorage.removeItem("activeBasePath");
    //     resolve();
    //   });
    // },

    // 左侧导航开关
    // SwitchClass({ commit }, switchClass) {
    //   return new Promise((resolve) => {
    //     commit("SET_SWITCHCLASS", switchClass);
    //     localStorage.setItem("switchClass", switchClass);
    //     resolve();
    //   });
    // },

    // 用户信息录入后设置token
    // SetToken({ commit }, tokenInfo) {
    //   return new Promise((resolve) => {
    //     setToken(tokenInfo.accessToken);
    //     commit("SET_TOKEN", tokenInfo.accessToken);
    //     setRefreshToken(tokenInfo.refreshToken);
    //     commit("SET_REFRESHTOKEN", tokenInfo.refreshToken);
    //     Cookies.set("dmpUserInfo", "");
    //     commit("SET_DMP_USERINFO", {});
    //     resolve();
    //   });
    // },
  },
}

export default user
